import * as yup from "yup"

export const LoginValidationSchema = yup.object().shape({
  userName: yup.string()
    .email()
    .required(),
  password: yup.string()
    .required()
});